var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-modal-overlay c-modal-overlay"},[_c('CelestialQuoteLineBasicInteractable',{staticClass:"c-quote-overlay",attrs:{"quote":_vm.quote}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }